module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0bd7e90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/index.vue
// module id = 1166
// module chunks = 0